import _defineProperty from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/inherits";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @format */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { graphql, compose } from 'react-apollo';
import MediaQuery from 'react-responsive';
import { Container, Layout, Spinner } from "../../_global";
import FAQs from "../../Faq/FAQs";
import { responsiveQuery } from "../../../constants/css";
import ErrorPage from "../../../pages/_error";
import { clearShopMerchant } from "../../../reducers/shop";
import { toggleFavourite } from "../../../reducers/user";
import TrackingUtilities from "../../../utils/trackingUtilities";
import { MALL_STATUS } from "../../../utils/mallStatus";
import { statusQuery } from "../../DirectContentForm/query";
import { gtagEvent } from "../../../utils/gtag";
import config from "../../../utils/clientConfig";
var ShopIcon = "/static/merchant/shop-icon.svg";
var TickIcon = "/static/merchant/tick-icon.svg";
import ImportantInfoFooter from "../Components/ImportantInfoFooter";
import logger from "../../../utils/logger";
import CircularJSON from 'circular-json';
import query from "../Detail/query";
import { merchantProps, merchantPropsDefault } from "../Detail/merchantProps";
import { MerchantWrapper, MerchantMain, MerchantContainer, FAQWrapper, OfferBox, InfoButton } from "../Style";
import { OfferDetails, OfferTitle, CTAWrapper, JoinCta, FindCta, LoadingWrapper } from "./style";
import CookieWarning from "../Detail/CookieWarning";
import LoginConfirmation from "../Detail/LoginConfirmation";
import About from "../Components/About";
import CustomisedButton from "../Components/CustomisedButton";
import TermsConditions from "../Components/TermsConditions";
import { buttonTypeLabel } from "../Enum/ButtonEnum";
import ResponsiveLogo from "../Components/ResponsiveLogo";
import TopBanner from "../Components/Banner";
import MerchantCoupon from "../Components/MerchantCoupon";
import MultipleCallout from "../Components/MultipleCallout";
var MerchantDetails = /*#__PURE__*/function (_Component) {
  function MerchantDetails(props) {
    var _this;
    _classCallCheck(this, MerchantDetails);
    _this = _callSuper(this, MerchantDetails, [props]);
    _this.toggleImportantInfo = function () {
      _this.setState(function (prevState) {
        return {
          showImportantInfo: !prevState.showImportantInfo
        };
      });
    };
    _this.renderShopIcon = function () {
      return __jsx("img", {
        src: ShopIcon,
        alt: "shop icon"
      });
    };
    _this.state = {
      showImportantInfo: false
    };
    return _this;
  }
  _inherits(MerchantDetails, _Component);
  return _createClass(MerchantDetails, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var merchant = this.props.merchant;
      TrackingUtilities.updatePageInfo({
        storeName: merchant.merchantName
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      TrackingUtilities.updatePageInfo({
        storeName: null
      });
      this.props.clearShopMerchant();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        loading = _this$props.loading,
        error = _this$props.error,
        merchant = _this$props.merchant,
        authenticated = _this$props.authenticated,
        authorized = _this$props.authorized,
        faqSections = _this$props.faqData.faqSections,
        checkDirectMemberStatus = _this$props.checkDirectMemberStatus;
      if (merchant && !merchant.isVisible) {
        return __jsx(ErrorPage, {
          statusCode: 404
        });
      }
      var isEnabledMallOffer = MALL_STATUS.isActive(merchant.merchantStatus);
      if (error && Object.keys(error).length > 0) {
        logger.error("Direct API call error ".concat(CircularJSON.stringify(error)));
      }
      if (merchant) {
        var metaTitle = merchant.metaTags || "".concat(merchant.merchantName, " | Qantas Shopping");
        var filteredFaq = merchant.merchantFaq && merchant.merchantFaq.length > 0 ? merchant.merchantFaq : faqSections && faqSections.filter(function (faq) {
          return merchant.merchantIdOLM && faq.id === 1 || merchant.merchantIdMCO && faq.id === 2 || merchant.merchantIdDirect && faq.id === 3;
        }).map(function (faq) {
          if (faq.id === 3) {
            return _objectSpread(_objectSpread({}, faq), {}, {
              title: merchant.merchantName
            });
          }
          return faq;
        });
        var joinLink = "/direct-member-join?mid=".concat(merchant.merchantId.replace(/\+/g, '%2B'));
        /* eslint-disable indent */
        return __jsx(Layout, {
          title: metaTitle,
          description: merchant.metaDescription,
          slug: merchant.merchantId,
          logo: merchant.merchantLogoSquare
        }, __jsx(CookieWarning, {
          merchantName: merchant.merchantName,
          merchantLogo: merchant.merchantLogoSquare
        }), __jsx(LoginConfirmation, {
          merchantId: merchant.merchantId,
          merchantIdOLM: merchant.merchantIdOLM
        }), __jsx(ResponsiveLogo, {
          merchant: merchant
        }), __jsx(MerchantWrapper, null, __jsx(TopBanner, {
          merchant: merchant
        }), __jsx(MerchantMain, {
          isGrey: true
        }, __jsx(Container, {
          wideView: true
        }, __jsx(OfferBox, null, __jsx(MediaQuery, {
          query: responsiveQuery.desktop
        }, __jsx("aside", null, __jsx("p", null, "IN-STORE"), this.renderShopIcon(), __jsx(InfoButton, {
          onClick: this.toggleImportantInfo
        }, "Terms & conditions"))), __jsx(OfferDetails, null, __jsx(MediaQuery, {
          query: responsiveQuery.mobile
        }, __jsx("p", null, "IN-STORE"), this.renderShopIcon()), __jsx(OfferTitle, null, "Earn ", __jsx("span", null, "2"), " Qantas Points per $1 spent"), __jsx("p", null, "on eligible products when you shop in-store and provide your TerryWhite Chemmart REWARDS account details"), loading && __jsx(LoadingWrapper, null, __jsx(Spinner, null), " ", __jsx("span", null, "Checking your status")), (error && Object.keys(error).length > 0 || checkDirectMemberStatus && !checkDirectMemberStatus.isAlreadyLinked || !authenticated && !authorized) && __jsx(CTAWrapper, null, __jsx(React.Fragment, null, __jsx(JoinCta, {
          pageLink: joinLink,
          primary: true,
          hasName: "join_".concat(merchant.merchantId)
        }, "join now", gtagEvent({
          action: 'conversion',
          tag: config.GTAG.TWCM_merchantPage,
          value: 'qanta0/tw-qa0+standard'
        })), __jsx(JoinCta, {
          pageLink: joinLink,
          outline: true,
          hasName: "link_".concat(merchant.merchantId)
        }, "link accounts", gtagEvent({
          action: 'conversion',
          tag: config.GTAG.TWCM_merchantPage,
          value: 'qanta0/tw-qa0+standard'
        })))), (authenticated || authorized) && checkDirectMemberStatus && checkDirectMemberStatus.isAlreadyLinked && __jsx(CTAWrapper, null, __jsx(React.Fragment, null, __jsx(LoadingWrapper, null, __jsx("img", {
          src: TickIcon,
          alt: "tick icon"
        }), __jsx("span", null, "Accounts linked")), __jsx("a", {
          target: "_blank",
          rel: "noopener noreferrer",
          href: "https://www.terrywhitechemmart.com.au/stores"
        }, __jsx(FindCta, {
          hasName: "find_".concat(merchant.merchantId),
          primary: true
        }, "find store")))), __jsx(TermsConditions, {
          merchant: merchant,
          onClick: this.toggleImportantInfo,
          showTerms: this.state.showImportantInfo
        }))))), __jsx(MerchantContainer, {
          wideView: true
        }, __jsx(MerchantMain, null, merchant.calloutBlock.length > 0 && __jsx(MultipleCallout, {
          merchantCallouts: merchant.calloutBlock
        }), filteredFaq && filteredFaq.length > 0 && __jsx(FAQWrapper, {
          wideView: true
        }, __jsx("h2", null, "Frequently asked questions"), __jsx(FAQs, {
          faqSections: filteredFaq
        })), __jsx(About, {
          merchant: merchant
        }), __jsx(CustomisedButton, {
          type: buttonTypeLabel.scrollTotop.type
        }), merchant.has_coupon && isEnabledMallOffer && __jsx(MerchantCoupon, {
          merchant: merchant
        })))), merchant.merchantImportantInfo && __jsx(ImportantInfoFooter, {
          merchantImportantInfo: merchant.merchantImportantInfo
        }));
      }
      return null;
    }
  }]);
}(Component);
MerchantDetails.defaultProps = merchantPropsDefault;
var mapStateToProps = function mapStateToProps(_ref) {
  var _ref$user = _ref.user,
    authenticated = _ref$user.authenticated,
    authorized = _ref$user.authorized,
    ffn = _ref$user.ffn;
  return {
    authenticated: authenticated,
    authorized: authorized,
    ffn: ffn
  };
};
var mapDispatchToProps = {
  toggleFavourite: toggleFavourite,
  clearShopMerchant: clearShopMerchant
};
export default compose(connect(mapStateToProps, mapDispatchToProps), graphql(query.merchantQuery, {
  options: function options(ownProps) {
    return {
      variables: {
        merchantId: ownProps.slug
      }
    };
  },
  props: function props(_ref2) {
    var data = _ref2.data;
    return data;
  }
}), graphql(query.getFAQs, {
  props: function props(_ref3) {
    var data = _ref3.data;
    return {
      faqData: data
    };
  },
  options: function options() {
    return {
      fetchPolicy: 'cache-and-network',
      ssr: false
    };
  }
}), graphql(statusQuery.edmStatusQuery, {
  skip: function skip(_ref4) {
    var authenticated = _ref4.authenticated,
      authorized = _ref4.authorized;
    return !authenticated && !authorized;
  },
  props: function props(_ref5) {
    var data = _ref5.data;
    return data;
  },
  options: function options(ownProps) {
    return {
      variables: {
        merchantId: ownProps.slug,
        memberId: null
      },
      ssr: false,
      fetchPolicy: 'network-only'
    };
  }
}))(MerchantDetails);